angular.module('picmonic-common').factory('Picmonics', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v2/picmonics/:card_id/:resource/:resource_id',
      {
        card_id: '@card_id',
        fact_id: '@fact_id',
        resource: '@resource',
        resource_id: '@resource_id',
      },
      {
        query: { method: 'GET', isArray: true },
        queryv3: {
          method: 'GET',
          url: '/api/v3/picmonics/:card_id/:resource/:resource_id',
          isArray: true,
        },
        get: { method: 'GET', isArray: false },
        update: { method: 'PUT', isArray: false },
        save: { method: 'POST', isArray: false },
        updatev3: {
          method: 'PUT',
          url: '/api/v3/picmonics/:card_id/:resource/:resource_id',
          isArray: false,
        },
        search: { method: 'GET', isArray: false, url: '/api/v3/picmonics' },
        saveEditorSession: {
          method: 'POST',
          isArray: false,
          url: '/api/v3/picmonics/:card_id/editor_sessions',
        },
        approvePremiumUgc: {
          method: 'POST',
          url: '/api/v3/admin/picmonics/:card_id/approve_premium_ugc',
        },
        submitVUGC: {
          method: 'POST',
          url: '/api/v3/admin/picmonics/:card_id/submit_vugc',
        },
        generator: {
          method: 'PUT',
          url: '/api/v3/picmonics/:card_id/generator/:resource/:resource_id',
          isArray: false,
        },
        cloneFact: {
          method: 'POST',
          url: '/api/v3/picmonics/:card_id/facts/:fact_id/clone',
          isArray: false,
        },
      }
    );
  },
]);
